var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter",attrs:{"data-testid":"workspace-switcher"}},[_c('Select',{ref:"select",attrs:{"label":"label","append-to-body":false,"options":_vm.options,"clearable":false,"reduce":(opt) => opt.value},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }